import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { translateData } from 'utils/translation';
import UnsupportedBrowserDialog from 'components/Dialogs/UnsupportedBrowserDialog';

const UnsupportedBrowser = () => (
  <Fragment>
    <Helmet title={translateData('Unsupported Browser')} />
    <UnsupportedBrowserDialog />
  </Fragment>
);

export default UnsupportedBrowser;
